import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAccount } from "wagmi";
import { useDynamic } from "../../../hooks/DynamicProvider";
import { updateUser } from "../../../api";
import InfoModal from "../../../components/InfoModal";
import "./access.css";
import { QRCodeSVG } from "qrcode.react";
import logo from "../../../assets/images/onboarding/access-logo.png";
import WalletButton from "../../../components/WalletConnectButton";
import Hub from "./hub";

const Access = ({ onNext, isMobile, containerHeight, containerWidth }) => {
  const { userInfo } = useDynamic();
  const { address, isConnected } = useAccount();

  const [searchParams] = useSearchParams();
  const short_code = searchParams.get("mbsy");

  const [copyStatus, setCopyStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCopy = async (copyText) => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopyStatus(true);
    } catch (error) {
      setCopyStatus(false);
    }
  };

  const currentUrl = window.location.href;

  const frames = Array.from(
    { length: 100 },
    (_, i) =>
      `../assets/images/onboarding/${(i + 1).toString().padStart(4, "0")}.png`
  );

  const nextStep = async () => {
    try {
      setIsLoading(true);
      if (short_code && !userInfo.parent_shortcode) {
        const result = await updateUser({ short_code });
        if (result && result.success) {
          onNext();
        }
      } else onNext();
    } catch (error) {
      // Handle unexpected errors gracefully
      console.error("Error in nextStep:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="access"
      style={{ height: isMobile ? "auto" : containerHeight }}
    >
      <div className="access-left">
        {!isMobile && (
          <div className="logo-block text-start">
            <img className="section-logo" src={logo} alt="logo" />
            {/* <i className="fa fa-info-circle float-end" /> */}
            <InfoModal className="fa fa-info-circle float-end" />
          </div>
        )}

        <div className="d-flex flex-column gap-3 flex-fill justify-content-center">
          <WalletButton
            className="btn btn-outline-primary"
            text={"Create Wallet"}
          />
          <button
            className="btn btn-primary"
            disabled={!isConnected}
            onClick={() => nextStep()}
          >
            {isLoading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              "Next Step"
            )}
          </button>
          {!isMobile && (
            <>
              <div className="d-flex align-items-center gap-4 qr-block">
                <QRCodeSVG value={currentUrl} />
                <div className="text-start">
                  <h3>Quick Access</h3>
                  <p>Scan the QR code with your phone to get access</p>
                </div>
              </div>
            </>
          )}
          <div className="text-start mt-4">
            {userInfo?.share_link && (
              <>
                <p style={{ color: "#346df6" }}>
                  Please share the below link with your friend&nbsp;
                  {copyStatus ? (
                    <i
                      className="fas fa-check-square cursor-pointer"
                      datatoggle="tooltip"
                      dataplacement="top"
                      title="Copied"
                      style={{ cursor: "pointer" }}
                    ></i>
                  ) : (
                    <i
                      className="fa fa-regular fa-copy cursor-pointer"
                      onClick={() => handleCopy(userInfo.share_link)}
                      datatoggle="tooltip"
                      dataplacement="top"
                      title="Copy"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </p>
                <p>{userInfo.share_link}</p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="access-right">
        {!!isMobile && (
          <div className="logo-block text-start position-absolute w-100 py-4 px-5">
            <img className="section-logo" src={logo} alt="logo" />
            <i className="fa fa-info-circle float-end" />
          </div>
        )}
        <div
          className="hub-block"
          style={{
            width: isMobile ? containerWidth : containerHeight,
            height: isMobile ? containerWidth : containerHeight,
          }}
        >
          <Hub
            width={isMobile ? containerWidth : containerHeight}
            height={isMobile ? containerWidth : containerHeight}
          />
        </div>

        {/* <CircularCarousel
          height={isMobile ? containerWidth : containerHeight}
        /> */}
      </div>
    </div>
  );
};

export default Access;
